const strings = {
  addBillingInfoMessage:
    'You must add a billing address before you can add a credit card',
  paymentSettingsHeader: 'Payment Settings',
  accountCredit: 'You have a credit on your account of $',
  oustandingBalance: 'You have an outstanding balance on your account of -$',
  yourCreditCards: 'Your credit cards',
  addPaymentMethod: 'Add a payment method',
  add: 'Add',
  defaultStr: 'Default',
  makeDefault: 'Make Default',
  exp: 'Exp',
  endingIn: 'Ending in',
  cancel: 'Cancel',
  del: 'Delete',
  save: 'Save',
  areYouSure: 'Are you sure you want to delete this payment method?',
  yesDeleteIt: 'Yes, delete it!',
  continuePayPal: 'Continue with PayPal',
  defaultCardError:
    'An error occured while setting your default card. Please, try again later.',
  deleteConfirmation: 'Are you sure you would like to delete this credit card?',
  deleteConfirmationDefault:
    'Are you sure you would like to delete your default credit card? A new default credit card will be automatically selected.',
  close: 'Close',
  retry: 'Retry',
  confirm: 'Confirm',
  editCCRetryMessage:
    'There was an issue saving your card. Please check your card details and try again.',
  retryMessage: 'There seems to be a problem, try again?',
  maxRetriesMessage: 'Max retries reached. Please contact support.',
  deleteModalTitle: 'Delete credit card',
  preauthorizationMessage:
    'Your credit card will be preauthorized for $1 for validation purposes.',
  secondPaypalAccount:
    "Looks like you already have PayPal linked to your account. If you'd like to change your PayPal funding source, you must delete your current PayPal account and add a new one. To do this, <a href='/my-account/settings/payment' target='_blank'><u>Go to Payment Settings</u></a>",
  expandSection: 'Expand section',
  collapseSection: 'Collapse section',
  edit: 'Edit',
  addPayPal:
    "You currently don't have a PayPal account set up. Click 'Add New PayPal' to set up a new one.",
  addCreditCard:
    "You currently don't have any credit cards added to your account. Click 'Add New Card' to add a new one.",
}

export { strings }
